import { useEffect, useState } from 'react';

export default function SecretSeminar202601Page() {
  const [visibleSections, setVisibleSections] = useState<string[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => [...prev, entry.target.id]);
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.fade-in-section').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // 外部フォームのHTML
  const formHTML = `
    <link rel="stylesheet" type="text/css" href="https://dynavisionasp.com/p/format_css?item_id=V5kcowzz&format=div&form_align=&label_align=&radio_float=&checkbox_float=&label_width=0&input_width=0&theme_name=3_7&ver=3" />
    <link rel="stylesheet" type="text/css" href="https://dynavisionasp.com/p/mobile_css?item_id=V5kcowzz&format=div&form_align=&label_align=&radio_float=&checkbox_float=&label_width=0&input_width=0&theme_name=3_7&ver=3" />
    <link rel="stylesheet" type="text/css" href="https://dynavisionasp.com/css/form/myasp-ui-form.css?d=20250810224710">
    
    <style>
      .form_input_label {
        white-space: normal !important;
        word-wrap: break-word !important;
        line-height: 1.6 !important;
      }
      .my_column.my_left {
        padding-right: 10px !important;
      }
      
      /* ボタンスタイルのカスタマイズ */
      .submit.form_input_submit {
        text-align: center !important;
        margin-top: 30px !important;
      }
      
      .submit.form_input_submit input[type="submit"] {
        background: linear-gradient(90deg, #FFA07A 0%, #FFB6A3 50%, #FFC8B4 100%) !important;
        color: white !important;
        font-size: 24px !important;
        font-weight: bold !important;
        padding: 24px 64px !important;
        border: none !important;
        border-radius: 50px !important;
        cursor: pointer !important;
        box-shadow: 0 8px 20px rgba(255, 160, 122, 0.4) !important;
        transition: all 0.3s ease !important;
        width: auto !important;
        display: inline-block !important;
      }
      
      .submit.form_input_submit input[type="submit"]:hover {
        transform: scale(1.05) !important;
        box-shadow: 0 12px 30px rgba(255, 160, 122, 0.6) !important;
      }
      
      /* タイトルの改行調整 */
      .content_title h2 {
        line-height: 1.6 !important;
      }
    </style>

    <div class="content_title">
        <h2>「最初の10人」と出会う<br />『スピリチュアル起業』突破口</h2>
    </div>

    <div class="content_form">
        <form action="https://dynavisionasp.com/p/r/V5kcowzz" enctype="multipart/form-data" id="UserItemForm" class="myForm" method="post" accept-charset="utf-8">
            <input type="hidden" name="_method" value="POST"/>
            
            <!-- 姓 -->
            <div class="input text input_unit  required">
                <div class="my_column my_left">
                    <div class="label_frame">
                        <label for="Username1" class="form_input_label  required">姓</label>
                    </div>
                </div>
                <div class="my_column my_right">
                    <input name="data[User][name1]" id="Username1" value="" class=" required" type="text"/>
                </div>
            </div>

            <!-- 名 -->
            <div class="input text input_unit  required">
                <div class="my_column my_left">
                    <div class="label_frame">
                        <label for="Username2" class="form_input_label  required">名</label>
                    </div>
                </div>
                <div class="my_column my_right">
                    <input name="data[User][name2]" id="Username2" value="" class=" required" type="text"/>
                </div>
            </div>

            <!-- メールアドレス -->
            <div class="input text input_unit  required">
                <div class="my_column my_left">
                    <div class="label_frame">
                        <label for="Usermail" class="form_input_label  required">メールアドレス</label>
                    </div>
                </div>
                <div class="my_column my_right">
                    <input name="data[User][mail]" id="Usermail" value="" class=" required" type="text"/>
                </div>
            </div>

            <!-- 今の正直なお気持ちや、 セミナーで聞いてみたいことがあれば 一言お書きください。  （例：自分の強みがわかりません、等。一言でも構いません） -->
            <div class="input text input_unit  required">
                <div class="my_column my_left">
                    <div class="label_frame">
                        <label for="Userfree9" class="form_input_label  required">今の正直なお気持ちや、 セミナーで聞いてみたいことがあれば 一言お書きください。  （例：自分の強みがわかりません、等。一言でも構いません）</label>
                    </div>
                </div>
                <div class="my_column my_right">
                    <input name="data[User][free9]" id="Userfree9" value="" class=" required" type="text"/>
                </div>
            </div>

            <!-- 確認ボタン -->
            <div class="submit form_input_submit">
                <input type="submit" value="参加登録"/>
            </div>
            
            <input type="hidden" id="server_url" value="https://dynavisionasp.com/"/>
            
        <!-- ▼リファラ -->
        <input type="hidden" name="data[User][referer_form_url]" value="" class="UserRefererFormUrl"/>
        <input type="hidden" name="data[User][referer_url]" value="" class="UserRefererUrl"/>

        <script type="text/javascript">
    if (document.referrer.length !=0 ){
        if (document.getElementsByClassName("UserRefererUrl"))
        {
        var user_referer_url = document.getElementsByClassName("UserRefererUrl");
        for (var i = 0; i < user_referer_url.length; i++)
        {
            user_referer_url[i].value = document.referrer;
        }
        }
        else if (document.getElementById("UserRefererUrl"))
        {
            document.getElementById("UserRefererUrl").value = document.referrer;
        }
    }

    if (document.getElementsByClassName("UserRefererFormUrl"))
    {
        var user_referer_form_url = document.getElementsByClassName("UserRefererFormUrl");
        for (var i = 0; i < user_referer_form_url.length; i++)
        {
            user_referer_form_url[i].value = location.href;
        }
    }
    else if (document.getElementById("UserRefererFormUrl"))
    {
        document.getElementById("UserRefererFormUrl").value = location.href;
    }
        </script>
        <!-- ▲リファラ -->

    </form>
    </div>

    <script src="https://dynavisionasp.com/js/validation.js?d=20260119134625"></script>
  `;

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 via-rose-50 to-orange-50 text-gray-800 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-orange-200/20 rounded-full blur-3xl"></div>
      <div className="absolute top-40 right-20 w-40 h-40 bg-pink-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-40 left-1/4 w-48 h-48 bg-amber-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-1/3 w-36 h-36 bg-rose-200/20 rounded-full blur-3xl"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-20">
        {/* Hero Section */}
        <section className="text-center mb-20 fade-in-section" id="hero">
          <div className="inline-block bg-gradient-to-r from-red-500 to-orange-500 text-white px-6 py-2 rounded-full text-sm font-bold mb-8 shadow-lg">
            緊急開催
          </div>
          
          <h1 className="text-2xl md:text-3xl font-bold mb-4 text-gray-700 leading-relaxed">
            資格はあるのに<br />
            動けないあなたへ
          </h1>
          
          <h2 className="text-3xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-amber-600 via-orange-600 to-rose-600 bg-clip-text text-transparent leading-tight">
            穴口恵子直伝
          </h2>
          
          <h3 className="text-2xl md:text-3xl font-bold mb-8 text-gray-800 leading-relaxed">
            「最初の10人」と出会うための<br />
            『スピリチュアル起業』突破口
          </h3>
          
          <p className="text-lg md:text-xl mb-12 text-gray-600 font-medium">
            なぜ、あなたの光は届かなかったのか？<br />
            その"構造"を解き明かす
          </p>

          {/* Date Info Box */}
          <div className="bg-gradient-to-br from-orange-100 to-pink-100 border-2 border-orange-300 rounded-2xl p-8 mb-8 shadow-xl">
            <p className="text-lg font-bold text-gray-700 mb-4">開催日時</p>
            <p className="text-3xl md:text-4xl font-bold text-orange-700 mb-4 text-center">1月24日(土)21:00〜</p>
            <div className="text-center">
              <a 
                href="https://dynavisionasp.com/p/r/V5kcowzz"
                className="inline-block bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-10 py-4 rounded-full text-xl font-bold shadow-xl transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                参加登録はこちら
              </a>
            </div>
          </div>
        </section>

        {/* Problems Section */}
        <section className="mb-20 fade-in-section" id="problems">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-xl border border-orange-200">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-center text-gray-800">
              こんなお悩み<br />
              ありませんか？
            </h3>
            
            <div className="space-y-4">
              {[
                '一生懸命に学んできた「資格」や「スキル」が、今は引き出しの中で眠っている',
                '「人を癒したい」「光を届けたい」という尊い想いがあるのに、一歩も動けない',
                '「集客が怖い」「お金を受け取ることに抵抗がある」「批判されたらどうしよう」',
                'そんな見えない壁に阻まれて、モヤモヤしたまま過ごしている'
              ].map((text, index) => (
                <div key={index} className="flex items-start gap-3 p-4 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl border border-orange-200">
                  <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-gradient-to-br from-orange-400 to-rose-400 text-white rounded-full text-sm font-bold mt-1">
                    ✓
                  </div>
                  <p className="text-gray-700 leading-relaxed">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Truth Section */}
        <section className="mb-20 fade-in-section" id="truth">
          <div className="bg-gradient-to-br from-rose-100 to-orange-100 rounded-3xl p-8 md:p-12 shadow-xl border-2 border-rose-300">
            <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center text-gray-800">
              はっきりとお伝えします
            </h3>
            
            <p className="text-xl md:text-2xl font-bold text-center mb-8 text-rose-700">
              それは、あなたのせいではありません。
            </p>
            
            <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
              <p>
                あなたが悪いのではなく、ただ<strong className="text-orange-700">「動けない構造」</strong>にハマっているだけなのです。
              </p>
              
              <p className="font-semibold">
                ・お金のブロックが<br />
                &nbsp;&nbsp;はずれていない
              </p>
              <p className="font-semibold">
                ・「集客」の本質が<br />
                &nbsp;&nbsp;見えていない
              </p>
              <p className="font-semibold">
                ・「最初の10人」の<br />
                &nbsp;&nbsp;見つけ方を知らない
              </p>
              
              <p className="mt-6">
                この3つの「構造」さえ理解すれば、あなたの光は必ず届きます。
              </p>
            </div>
          </div>
        </section>

        {/* Message Section */}
        <section className="mb-20 fade-in-section" id="message">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-xl border border-orange-200">
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                このオンラインセミナーでは、<strong className="text-orange-700">穴口恵子が20年以上かけて築いてきた「スピリチュアル起業の土台」</strong>を、惜しみなくシェアします。
              </p>
              
              <p className="font-semibold text-xl text-gray-800">
                ・お金のブロックを一瞬で外す「魔法の言葉」
              </p>
              <p className="font-semibold text-xl text-gray-800">
                ・「最初の10人」と必ず出会える"集客の仕組み"
              </p>
              <p className="font-semibold text-xl text-gray-800">
                ・あなたの"使命"が明確になる「3つの質問」
              </p>
              
              <p className="mt-8 text-xl font-bold text-center text-rose-700">
                この3つを知るだけで、あなたの世界は動き出します。
              </p>
              
              <p className="mt-8 text-center">
                もう迷う必要はありません。<br />
                あなたの光を、必要としている人のもとへ届けましょう。
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section with Embedded Form */}
        <section className="text-center fade-in-section" id="cta">
          <div className="bg-gradient-to-br from-amber-100 to-rose-100 rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-orange-300 mb-8">
            <p className="text-xl md:text-2xl font-bold mb-6 text-gray-800">
              1月24日（土）21:00〜<br />
              オンライン開催（参加無料）
            </p>
            
            {/* 埋め込みフォーム */}
            <div dangerouslySetInnerHTML={{ __html: formHTML }} />
          </div>
          
          <p className="text-sm text-gray-600">
            ※お申し込み後、ZoomのURLをお送りいたします
          </p>
        </section>
      </div>
    </div>
  );
}
